if (!window.Eurus.loadedScript.has('affiliate-discount.js')) {
  window.Eurus.loadedScript.add('affiliate-discount.js');

  (() => {
    const storageKey = 'ogAffiliateBgRef';

    const getBgRef = () => {
      try {
        const urlBgRef = new URLSearchParams(window.location.search).get('bg_ref') || '';

        if (urlBgRef) {
          sessionStorage.setItem(storageKey, urlBgRef);
          return urlBgRef;
        }

        return sessionStorage.getItem(storageKey) || '';
      } catch {
        return '';
      }
    };

    const normalize = (value) => value.toString().trim().toLowerCase();
    const normalizeReference = (value) => normalize(value).replace(/^\?bg_ref=|^bg_ref=/, '');

    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (Number.isNaN(number) || number == null) return '0';

      const parts = (number / 100).toFixed(precision).split('.');
      const units = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const cents = parts[1] ? decimal + parts[1] : '';

      return units + cents;
    };

    const formatMoney = (amount, formatString, currencyCode) => {
      if (window.Alpine && Alpine.store('xHelper')?.formatMoney) {
        return Alpine.store('xHelper').formatMoney(amount, formatString);
      }

      const format = formatString || '{{amount_with_comma_separator}}';
      const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);

      if (!placeholderMatch) {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-AT', {
          style: 'currency',
          currency: currencyCode || window.Shopify?.currency?.active || 'EUR'
        }).format(amount / 100);
      }

      let value;
      switch (placeholderMatch[1]) {
        case 'amount':
          value = formatWithDelimiters(amount, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(amount, 2, '.', ',');
      }

      return format.replace(placeholderMatch[0], value);
    };

    const getVariantPrice = (sectionId) => {
      const priceElement = document.querySelector(`#price-${sectionId} .target-price`);
      return Number.parseInt(priceElement?.textContent || '0', 10);
    };

    const copyCodeFallback = (code) => {
      return new Promise((resolve, reject) => {
        const input = document.createElement('textarea');
        input.value = code;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '-9999px';
        document.body.append(input);
        input.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (error) {
          reject(error);
        } finally {
          input.remove();
        }
      });
    };

    const copyCode = (code) => {
      if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(code).catch(() => copyCodeFallback(code));
      }

      return copyCodeFallback(code);
    };

    const renderDiscount = (target, money, code) => {
      const highlight = (element) => {
        element.style.fontWeight = '700';
        element.style.textDecoration = 'underline';
        element.style.textUnderlineOffset = '4px';
      };

      const wrapper = document.createElement('span');
      wrapper.className = 'affiliate-discount__inner inline-flex items-center justify-center gap-2 flex-wrap';

      const priceElement = document.createElement('span');
      priceElement.className = 'affiliate-discount__price underline underline-offset-4 font-bold';
      priceElement.textContent = money;
      priceElement.style.fontSize = '1.15em';
      highlight(priceElement);

      const copyButton = document.createElement('button');
      copyButton.type = 'button';
      copyButton.className = 'affiliate-discount__copy inline-flex items-center justify-center cursor-pointer';
      const copyIcon = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><rect x="8" y="4" width="11" height="15" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><path d="M5 8v10a2 2 0 0 0 2 2h8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      copyButton.style.color = 'inherit';
      copyButton.style.background = 'transparent';
      copyButton.style.border = '0';
      copyButton.style.padding = '0';
      copyButton.style.minWidth = '22px';
      copyButton.style.minHeight = '22px';
      copyButton.style.fontSize = '0.9em';
      copyButton.style.fontWeight = '700';
      copyButton.style.lineHeight = '1';
      copyButton.setAttribute('aria-label', `Rabattcode ${code} kopieren`);
      copyButton.innerHTML = copyIcon;
      copyButton.addEventListener('click', () => {
        copyCode(code)
          .then(() => {
            copyButton.setAttribute('aria-label', `Rabattcode ${code} kopiert`);
            copyButton.textContent = 'Kopiert';
            copyButton.style.opacity = '0.65';

            setTimeout(() => {
              copyButton.setAttribute('aria-label', `Rabattcode ${code} kopieren`);
              copyButton.innerHTML = copyIcon;
              copyButton.style.opacity = '1';
            }, 1200);
          })
          .catch(() => {});
      });

      const codeElement = document.createElement('span');
      codeElement.className = 'affiliate-discount__code underline underline-offset-4 font-bold';
      codeElement.textContent = code;
      highlight(codeElement);

      wrapper.append(priceElement, ' mit dem Code: ', copyButton, codeElement);
      target.replaceChildren(wrapper);
    };

    const updateDiscount = (state) => {
      const { data, discount, sectionId, target } = state;
      const variantPrice = getVariantPrice(sectionId);

      if (!discount || !target || !variantPrice) {
        target?.classList.add('hidden');
        return;
      }

      const discountedPrice = Math.round(variantPrice * (100 - discount.percent) / 100);
      const money = formatMoney(discountedPrice, data.moneyFormat, data.currencyCode);

      renderDiscount(target, money, discount.code);
      target.classList.remove('hidden');
      target.style.visibility = 'visible';
      target.style.minHeight = '';
    };

    const initDiscount = (dataElement) => {
      const sectionId = dataElement.id.replace('AffiliateDiscountData-', '');
      const target = document.getElementById(`affiliate-discount-${sectionId}`);
      const bgRef = getBgRef();

      if (!target || !bgRef) return;

      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch {
        return;
      }

      const discount = data.discounts?.find((entry) => normalizeReference(entry.reference) === normalize(bgRef));
      const state = { data, discount, sectionId, target };

      updateDiscount(state);
      document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, () => {
        requestAnimationFrame(() => updateDiscount(state));
      });
    };

    const init = () => {
      document.querySelectorAll('[id^="AffiliateDiscountData-"]').forEach(initDiscount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
}
